import {
  ProductionColumn,
  ProductionColumnHeader,
  ProductionColumnHeaderResponse,
} from 'src/app/interfaces/production-column';

export const PRODUCTION_COLUMN_HEADERS: ProductionColumnHeader[] = [
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '6qTND',
    assemblyName: 'ESP',
    assemblySize: 4.5,
    installDate: new Date('2019-10-19T00:00:00'),
    mdLanded: 1963.34,
    confirmed: true,
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: 'E4aQR',
    assemblyName: 'ESP CSG',
    assemblySize: 4.5,
    installDate: new Date('2020-05-11T00:00:00'),
    mdLanded: 1937.9,
    confirmed: false,
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyName: 'ESP',
    assemblySize: 2.875,
    installDate: new Date('2020-05-11T00:00:00'),
    mdLanded: 2001.66,
    confirmed: false,
  },
];

export const PRODUCTION_COLUMNS: ProductionColumn[] = [
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '6qTND',
    assemblyCompId: 'AlRMs',
    assemblyName: 'ESP',
    sequenceNo: 0,
    component: 'CAMISA TR3 CT y acople camisa/camisa DESANDER',
    joints: 1,
    threads: 'EUE',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1927.34,
    length: 6,
    statusInstallDate: new Date('2019-10-19T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1921.34,
    size: 4.5,
    weight: 60,
    comments: 'Postman test',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '6qTND',
    assemblyCompId: 'bhGMO',
    assemblyName: 'ESP',
    sequenceNo: 1,
    component: 'CAMISA TR3 CT y acople camisa/camisa',
    joints: 5,
    threads: 'EUE',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1957.34,
    length: 30,
    statusInstallDate: new Date('2019-10-19T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1927.34,
    size: 4.5,
    weight: 47,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '6qTND',
    assemblyCompId: 'cD1iP',
    assemblyName: 'ESP',
    sequenceNo: 2,
    component: 'CAMISA TR3 UT c/dados y acople C/COLLARIN',
    joints: 1,
    threads: 'EUE',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1963.34,
    length: 6,
    statusInstallDate: new Date('2019-10-19T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1957.34,
    size: 4.5,
    weight: 47,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'etwEf',
    assemblyName: 'ESP',
    sequenceNo: 0,
    component: 'TUBING, 2.875, 6.5#, J-55, EUE',
    joints: 1,
    threads: 'EUE 8RD',
    manufacturer: 'SIDERCA',
    mdBase: 5.48,
    length: 1.21,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 4.27,
    size: 2.875,
    weight: 6.5,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: '33y4j',
    assemblyName: 'ESP',
    sequenceNo: 1,
    component: 'TUBING, 2.875, 6.5#, J-55, EUE',
    joints: 194,
    threads: 'EUE 8RD',
    manufacturer: 'SIDERCA',
    mdBase: 1868.26,
    length: 1862.78,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'ORIG. WELL',
    mdTop: 5.48,
    size: 2.875,
    weight: 6.5,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'Vokxa',
    assemblyName: 'ESP',
    sequenceNo: 2,
    component: 'NIPPLE TUBING, 2.875',
    joints: 1,
    threads: 'EUE 8RD',
    manufacturer: 'SIDERCA',
    mdBase: 1869.47,
    length: 1.21,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1868.26,
    size: 2.875,
    weight: 6.5,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: '4r4JO',
    assemblyName: 'ESP',
    sequenceNo: 3,
    component: 'NIPPLE, SEAT BHD 2.875',
    joints: 1,
    threads: 'EUE 8RD',
    manufacturer: 'SIDERCA',
    mdBase: 1869.79,
    length: 0.32,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1869.47,
    size: 2.875,
    weight: 6.5,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'ukMnT',
    assemblyName: 'ESP',
    sequenceNo: 4,
    component: 'DESCARGA BOMBA GE TR4 2-7/8"',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1869.97,
    length: 0.18,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1869.79,
    size: 4.0,
    weight: 4.5,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'yK2kc',
    assemblyName: 'ESP',
    sequenceNo: 5,
    component: 'TD2200 FLT  84STG #10 AR H&B HSS',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1874.48,
    length: 4.51,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1869.97,
    size: 4.0,
    weight: 172.8,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'V0SEr',
    assemblyName: 'ESP',
    sequenceNo: 6,
    component: 'TD2200 FLT 100STG #12 AR H&B',
    joints: 2,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1885.2,
    length: 10.72,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1874.48,
    size: 4.0,
    weight: 206.4,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'ZMAZs',
    assemblyName: 'ESP',
    sequenceNo: 7,
    component: 'TD2200 FLT  84STG #10 AR H&B HSS',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1889.71,
    length: 4.51,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1885.2,
    size: 4.0,
    weight: 172.8,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'Jj3VR',
    assemblyName: 'ESP',
    sequenceNo: 8,
    component: 'TD2200 FLT 100STG #12 AR H&B',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1895.07,
    length: 5.36,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1889.71,
    size: 4.0,
    weight: 206.4,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'dsQug',
    assemblyName: 'ESP',
    sequenceNo: 9,
    component: 'INTAKE,HGR SLD TD/TR381 MLC .378 AR*',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1895.4,
    length: 0.33,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1895.07,
    size: 4.5,
    weight: 12.7,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'SugRM',
    assemblyName: 'ESP',
    sequenceNo: 10,
    component: 'SEAL,TR3 STD HL HT W/O LP',
    joints: 2,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1898.62,
    length: 3.22,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1895.4,
    size: 3.5,
    weight: 0,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'Zd8GA',
    assemblyName: 'ESP',
    sequenceNo: 11,
    component: 'SEAL,TR381 AR LAB/LAB TO TR3 MOTOR',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1900.28,
    length: 1.66,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1898.62,
    size: 3.5,
    weight: 0,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'oB5UJ',
    assemblyName: 'ESP',
    sequenceNo: 12,
    component: 'E37-10   45\\1037\\33 UT HTI LP',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1909.18,
    length: 8.9,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1900.28,
    size: 3.75,
    weight: 589,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'Di1rY',
    assemblyName: 'ESP',
    sequenceNo: 13,
    component: 'E37-10   45\\1037\\33 CT HTI LP',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1918.08,
    length: 8.9,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1909.18,
    size: 3.75,
    weight: 589,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'JOaaJ',
    assemblyName: 'ESP',
    sequenceNo: 14,
    component: 'E37-10   37.5\\864\\33 CT HTI LP',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1925.58,
    length: 7.5,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1918.08,
    size: 3.75,
    weight: 490,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'jloup',
    assemblyName: 'ESP',
    sequenceNo: 15,
    component: 'E37-10   22.5\\518\\33 CT HTI LP',
    joints: 1,
    threads: 'ACME',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1930.48,
    length: 4.9,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1925.58,
    size: 3.75,
    weight: 312,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'oH8J1',
    assemblyName: 'ESP',
    sequenceNo: 16,
    component: 'SENSOR TIPO 375 PRESION DE INTAKE',
    joints: 2,
    threads: 'ACME',
    manufacturer: 'SCHLUMBERGER',
    mdBase: 1931.53,
    length: 1.05,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1930.48,
    size: 3.5,
    weight: 30,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'PxVlm',
    assemblyName: 'ESP',
    sequenceNo: 17,
    component: 'DESARENADOR CAVINS P/BES  CONEXIÓN  2 7/8"',
    joints: 4,
    threads: 'ACME',
    manufacturer: 'OTHER',
    mdBase: 1933.86,
    length: 2.33,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'C',
    condition: 'NEW EQUIP',
    mdTop: 1931.53,
    size: 0.0,
    weight: 7.5,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'GLSbo',
    assemblyName: 'ESP',
    sequenceNo: 18,
    component: 'TUBING, 2.875, 6.5#, J-55, EUE',
    joints: 7,
    threads: 'EUE 8RD',
    manufacturer: 'SIDERCA',
    mdBase: 2001.41,
    length: 67.55,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'YELLOW',
    mdTop: 1933.86,
    size: 2.875,
    weight: 6.5,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: '30i11',
    assemblyCompId: 'ns8x5',
    assemblyName: 'ESP',
    sequenceNo: 19,
    component: 'PLUG 2 7/8',
    joints: 1,
    threads: 'EUE 8RD',
    manufacturer: 'SIDERCA',
    mdBase: 2001.66,
    length: 0.25,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 2001.41,
    size: 2.875,
    weight: 0,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: 'E4aQR',
    assemblyCompId: 'V7Jn7',
    assemblyName: 'ESP CSG',
    sequenceNo: 0,
    component: 'CAMISA TR3 CT y acople camisa/camisa DESANDER',
    joints: 1,
    threads: 'EUE',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1901.9,
    length: 6,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1895.9,
    size: 4.5,
    weight: 60,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: 'E4aQR',
    assemblyCompId: 'sNeSi',
    assemblyName: 'ESP CSG',
    sequenceNo: 1,
    component: 'CAMISA TR3 CT y acople camisa/camisa',
    joints: 5,
    threads: 'EUE',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1931.9,
    length: 30,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1901.9,
    size: 4.5,
    weight: 47,
    comments: '',
  },
  {
    handoverId: 1234,
    wellId: '5400004469',
    wellboreId: '5400004469',
    assemblyId: 'E4aQR',
    assemblyCompId: 'KBjn5',
    assemblyName: 'ESP CSG',
    sequenceNo: 2,
    component: 'CAMISA TR3 UT c/dados y acople C/COLLARIN',
    joints: 1,
    threads: 'EUE',
    manufacturer: 'GE OIL & GAS',
    mdBase: 1937.9,
    length: 6,
    statusInstallDate: new Date('2020-05-11T00:00:00'),
    grade: 'J-55',
    condition: 'NEW EQUIP',
    mdTop: 1931.9,
    size: 4.5,
    weight: 47,
    comments: '',
  },
];

export const PRODUCTION_COLUMN_HEADERS_RESPONSE: ProductionColumnHeaderResponse =
  {
    headers: [PRODUCTION_COLUMN_HEADERS[0]],
    confirmedHeaders: true,
  };
